<template>
   <div class="animated fadeIn">
      <!-- Main Wifi landing spot -->
      <b-card>
        <b-row>
           <b-col md="12" class="text-center">
            <h1 class="display-3">Data Deep Dive</h1>
              <b-row md="12" class="w-100 text-center justify-content-center align-self-center">
                <img src="https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png">
              </b-row>
                <b-card variant="accent-info" header="Card with accent" class="border-primary">
                 The statistics and infographics created on the previous page were generated from exploring the data. It is through data understanding and exploration that valueable insights can be gained.<br><br>
                 
                 For example, it is intuitive to most that weather will impact visitor counts on the Downtown Mall, but being able to quantify the impact is how this wifi data can become most useful. The "Weather and Wifi" infographic aimed to do just that. It also confirmed those suspicions.<br>

                 Most business owners know that wifi users on the downtown mall most likely use social media apps or visit media delivery websites, such as YouTube. Now the data has been explored to understand these usage patterns. <br>

                 This page serves as an exploration and additional page to dive deeper into the data.<br>
               </b-card>
              <!-- TODO: Footer does not extend all the way to the left -->
             <b-row md="12" class="w-100 text-center justify-content-center align-self-center">
               <img src="https://image.ibb.co/h23nQS/HOMEPAGE_ARROW_UP.png">
             </b-row>
           </b-col>
        </b-row>
      </b-card>


      <!-- Clients per Day Line Plot Understanding Patterns -->
      <b-card>
       <b-row>
          <b-col md="12" class="text-center">
             <img src="https://preview.ibb.co/eGVR27/understanding_patterns.png">
          </b-col>
       </b-row>
       <b-row class="text-center justify-content-center align-self-center">
        <b-card header="Scope of Exploration" class="border-secondary mt-2">
            Three-hundred and fifty three days were analyzed during 2017 to learn about the usage of Wifi on the downtown mall. Wifi users were denoted as "clients" and the number of clients per day was provided. Each day, a certain number of wifi sessions were also recorded. Finally, the total kilobytes downloaded and total kilobytes used during those sessions were tracked. 
         </b-card>
       </b-row>
       <br>
       <b-row>
          <b-col md="12">
             <line-example/>
          </b-col>
       </b-row>
      </b-card>


      <!-- Top Mobile App Data Usage block -->
      <b-card>
        <b-row class="p-4">
           <b-col md="6" class="text-center justify-content-center align-self-center">
             <b-card header="Key Takeaways from Mobile App Usage" class="border-secondary mt-2">
              It was through the exploration of additional data sources. 
             </b-card>
           </b-col>

           <b-col md="6" class="text-center justify-content-center align-self-center">
             <b-row>
              <b-col md="12" class="text-right">
                <img src="https://image.ibb.co/c0xQc7/Top_20_Mobile_Apps.png" class="img-fluid">
              </b-col>
            </b-row>
           </b-col>
        </b-row>

        <!-- Bottom row of 3 pie charts showing App Usage -->
        <b-row>
           <b-col md="4" class="text-center justify-content-center align-self-center">
              <h4 class="">Social Media App Usage</h4>
              <pie-example :labels=labels_app_social :dataPoints=data_app_social />
           </b-col>
           <b-col md="4" class="text-center justify-content-center align-self-center">
              <h4 class="">Music App Usage</h4>
              <pie-example :labels=labels_app_music :dataPoints=data_app_music />
           </b-col>
           <b-col md="4" class="text-center justify-content-center align-self-center">
              <h4 class="">Video App Usage</h4>
              <pie-example :labels=labels_app_video :dataPoints=data_app_video />
           </b-col>
        </b-row>
      </b-card>
      <br>

      <!-- Top Mobile Device Brands -->
      <b-card>
         <b-col md="12" class="text-center justify-content-center align-self-center">
          <img src="https://image.ibb.co/kdvmH7/Top_10_Mobile_Brands.png" class="img-fluid">
        </b-col>
        <b-row class="p-4">
           <b-col md="8" class="text-center justify-content-center align-self-center">
              <b-card header="What could we do with this data?" class="border-secondary mt-2">
              - Events to draw more Apple or tech users to the downtown mall may bring in greater volume for tech business and increase the number of wifi users.
               <br> - Consider opening a technology related store, such as an Apple store or device repair store, on the mall. 
               <br> - Alternatively, bring in these specific vendors during key technology related events such as the TomTom Festival.
            </b-card>
          </b-col>
           <!-- Top Device Pie Chart  -->
         <b-col md="4" class="text-center justify-content-center align-self-center">
          <!-- TODO check on undefined -->
            <pie-example :labels=labels_mobile :dataPoints=data_mobile />
            <!-- Card under the pie chart -->
            <b-card header="Top Mobile Device Key Takeaways" class="border-secondary">
                - Apple dominates with the most users per device (29.49% of all users).<br> 
                - Samsung and LG additionally make up a large percentage of total device usage.<br>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
     <br>

      <!-- Top Annual Events Colorful Tent Image -->
      
     <!-- Sub event Key Events panel 1 -->
      <b-row>
         <b-col md="8" class="text-center">
          <img src="static/img/events_1.png" class="w-100">
         </b-col>
          <b-col md="4" class="text-center">
           <b-card header="Key Events" class="border-secondary">
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
            </b-card>
         </b-col>
      </b-row>
       <!-- Sub event Festivals panel 2 -->
       <b-row>
            <!-- TODO: Make the chart labels much smaller so it fits nicely next to the green image -->
            <!-- TODO: Or even better, put the title and labels in the spot above this pie chart -->
            <b-col md="12" class="text-center justify-content-center align-self-center">
             <div class="chart-wrapper">
              <!-- Add title to the pie chart -->
              <!-- Add labels to say "Number of Clients" -->
              <h6 class="">Yearly Number of Clients By Event Type</h6>
              <pie-example :labels=labels_events :dataPoints=data_events />
             </div>

         </b-col>
      </b-row>
     <!-- Sub event Holidays panel 3 -->
       <b-row>
          <b-col md="12" class="text-center justify-content-center align-self-center">
           <!-- Day of the Week bar chart here -->
             <bar-example :labels=labels_dates :dataPoints=data_dates />
         </b-col>
      </b-row>
     </b-card>

    

   </div>
</template>

       <!-- <div class="card-columns cols-2 ">
          <b-card header="Line Chart col-12">
             <div class="chart-wrapper">
                <line-example/>
             </div>
          </b-card>
          <b-card header="Bar Chart">
             <div class="chart-wrapper">
                <bar-example/>
             </div>
          </b-card>
          <b-card header="Doughnut Chart">
             <div class="chart-wrapper">
                <doughnut-example/>
             </div>
          </b-card>
          <b-card header="Radar Chart">
             <div class="chart-wrapper">
                <radar-example/>
             </div>
          </b-card>
          <b-card header="Pie Chart">
             <div class="chart-wrapper">
                <pie-example/>
             </div>
          </b-card>
          <b-card header="Polar Area Chart">
             <div class="chart-wrapper">
                <polar-area-example/>
             </div>
          </b-card>
       </div>
    </div>
 </template>

import BarExample from './charts/BarExample'
import LineExample from './charts/LineExample'
import DoughnutExample from './charts/DoughnutExample'
import RadarExample from './charts/RadarExample'
import PieExample from './charts/PieExample'
import PolarAreaExample from './charts/PolarAreaExample'
export default {
  name: 'dashboard',
  components: {
    BarExample,
    LineExample,
    DoughnutExample,
    RadarExample,
    PieExample,
    PolarAreaExample
  }
}
</script> -->

<script>
    import LineExample from './charts/LineExample'
    import PieExample from './charts/PieExample'
    import BarExample from './charts/BarExample'

    export default {
      name: 'story',
      data () {
        return {
          labels_app: ['label'],
          data_app: [12],
          // Title: "Social Media App Usage"
          labels_app_social: ['Facebook', 'Tumblr', 'Instagram', 'Snapchat'],
          data_app_social: [42.8, 5.6, 30.2, 21.4],
          // Title: "Music App Usage"
          labels_app_music: ['iTunes', 'Spotify', 'Misc. audio', 'Pandora'],
          data_app_music: [64.3, 20.1, 8.4, 7.2],
          // Title: Video App Usage
          // TODO: Make the color of the pie match the App
          // TODO: social media icons
          labels_app_video: ['YouTube', 'Misc. video', 'Netflix'],
          data_app_video: [68.6, 13.5, 17.8],
          labels_mobile: ['Apple', 'Samsung', 'Murata Mfg', 'Intel', 'Kyocera', 'Motorola', 'HTC', 'Huawei Tech'],
          data_mobile: [6544, 742, 420, 531, 140, 153, 230, 360, 119, 75],
          // TODO: Make this pie chart and labels green
          // green_colors: ['#32CD32', '#228B22', '#006400', '#ADFF2F', '#00FF7F', '#3CB37', '#808000', '#008000']
          labels_events: ['Festivals', 'Fridays After Five', 'General', 'Holiday', 'Kids Event', 'Movie', 'Speaker/Performance', 'Theme Week'],
          data_events: [172, 212, 111, 102, 90, 101, 136, 95],
          // Clients by Days of the Week
          labels_dates: ['Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun'],
          data_dates: [96, 112, 121, 119, 154, 134, 94]
        }
      },
      components: {
        LineExample,
        PieExample,
        BarExample
      }
}
</script>


// WEBPACK FOOTER //
// src/views/Data.vue